
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface FlightSearchBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

export function FlightSearchBar({ searchTerm, onSearchChange }: FlightSearchBarProps) {
  return (
    <div className="flex w-full max-w-sm items-center space-x-2">
      <Input
        placeholder="Search flights, cities or airlines..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="flex-1 border-2 border-foreground"
        aria-label="Search flights"
      />
      <Button type="submit" size="icon" variant="ghost" aria-label="Search">
        <Search className="h-4 w-4" />
        <span className="sr-only">Search</span>
      </Button>
    </div>
  );
}
